"use strict";

exports.__esModule = true;
exports.loadConfig = exports.WhoAmI = void 0;

var _belgianBrands = require("../whoami/config/belgianBrands");

var _belgianBrands2 = require("../whoami/config/belgianBrands.production");

var _mhnlBrands = require("../whoami/config/mhnlBrands");

var _mhnlBrands2 = require("../whoami/config/mhnlBrands.production");

var _mhluBrands = require("../whoami/config/mhluBrands");

var _mhluBrands2 = require("../whoami/config/mhluBrands.production");

var _mhaaBrands = require("../whoami/config/mhaaBrands");

var _mhaaBrands2 = require("../whoami/config/mhaaBrands.production");

// Imports for MHBE
// Imports for MHNL
// Imports for MHLU
// Imports for MHAA

/**
 * This class contains all the logic to load the environment configuration details for a specific brand - environment configuration
 * @todo refactor to remove unused code in build process or dynamically load profile
 * @export
 * @class WhoAmI
 */
class WhoAmI {
  constructor(bootstrapConfig) {
    this.profileSelector = `${bootstrapConfig.entity}-${bootstrapConfig.brandCode}-${bootstrapConfig.environment}`;

    if (bootstrapConfig.environment !== 'production') {
      console.log('Profile selected: ', this.profileSelector);
    }

    this.config = this.loadConfig(bootstrapConfig.entity, bootstrapConfig.brandCode, bootstrapConfig.environment);
  }

}
/**
 * this loads the specific configuration for a brand - env configuration
 *  @todo needs refactoring for generic load
 *
 * @memberof WhoAmI
 */


exports.WhoAmI = WhoAmI;

const loadConfig = function (entity, brandCode, environment) {
  try {
    let configfile;

    switch (entity) {
      case 'mhbe':
        configfile = environment === 'production' ? (0, _belgianBrands2.config)(brandCode, environment) : (0, _belgianBrands.config)(brandCode, environment);
        break;

      case 'mhnl':
        configfile = environment === 'production' ? (0, _mhnlBrands2.config)(brandCode, environment) : (0, _mhnlBrands.config)(brandCode, environment);
        break;

      case 'mhlu':
        configfile = environment === 'production' ? (0, _mhluBrands2.config)(brandCode, environment) : (0, _mhluBrands.config)(brandCode, environment);
        break;

      case 'mhaa':
        configfile = environment === 'production' ? (0, _mhaaBrands2.config)(brandCode, environment) : (0, _mhaaBrands.config)(brandCode, environment);
        break;

      default:
        configfile = {};
    }

    return Promise.resolve(configfile); // this fetches on a remote location a config file
    // apiCall(
    //   `https://glitr-tracking-configuration.s3-eu-west-1.amazonaws.com/${brandCode}/${environment}/config.json`,
    //   {
    //     method: 'GET',
    //     headers: {
    //       'content-type': 'application/json',
    //     },
    //     onSuccess: response => {
    //       // console.log('response.data', response.data);
    //       return response.data;
    //     },
    //   },
    // );
  } catch (e) {
    return Promise.reject(e);
  }
};

exports.loadConfig = loadConfig;